<!-- <div class="container-fluid">
  <div class="page-title">
    <div class="row row--gutter">
      <div class="col-6">
        <h3>{{title}}</h3>
      </div>
      <div class="col-12">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a [routerLink]="'/dashboard/default'">
              <app-feather-icons [icon]="'home'"></app-feather-icons>
            </a>
          </li>
          <li class="breadcrumb-item" *ngFor="let item of items"> {{item}} </li>
          <li class="breadcrumb-item active"> {{active_item}} </li>
        </ol>
      </div>
    </div>
  </div>
</div> -->

<div class="d-block">
  <div class="page-title">
    <div class="row row--gutter">
      <div class="col-12 text-left">
        <ol class="breadcrumb">
          <li class="page-name mr-3">
            <h3>{{title}}</h3>
          </li>
          <li class="breadcrumb-item">
            <a [routerLink]="'/ondc/orderlist'">
              <app-feather-icons [icon]="'home'"></app-feather-icons>
            </a>
          </li>
          <li class="breadcrumb-item" *ngFor="let item of items">{{item}}</li>
          <li class="breadcrumb-item active">{{active_item}}</li>
        </ol>
      </div>
    </div>
  </div>
</div>
